export default __webpack_public_path__ + "static/media/JensenLakesCrossing.6766ef6b.jpg";